
import { onClickOutside } from '@/directives/onClickOutside';
import SelectConversation from '@/components/graph/common/SelectConversation';

export default {
  components: { SelectConversation },

  directives: {
    'click-outside': onClickOutside,
  },

  props: {
    disableCurrentConversation: { type: Boolean, default: true },
    disableCurrentAmp: { type: Boolean, default: true },
    onClose: { type: Function, default: () => {} },
    onSelectConversation: { type: Function, default: () => {} },
    selectedAmpId: { type: String, default: '' },
    selectedConversationId: { type: String, default: '' },
    backgroundColor: { type: String, default: '' },
    title: { type: String, default: '' },
    searchThroughEDetails: { type: Boolean, default: false },
  },
};
